<template>
  <div class="container-fluid">
    <section class="mb-3">
      <DashboardMyOrganization :organization="organization"
                               @refreshOrganization="handleRefreshOrganization" />
    </section>
    <section class="mb-3">
      <DashboardConversations :conversations="conversations" />
    </section>
    <section>
      <DashboardPendingReports :pendingReports="pendingReports" />
    </section>
  </div>
</template>
<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { onMounted } from 'vue';
// Components
import DashboardMyOrganization from '../dashboard/DashboardMyOrganization.vue';
import DashboardConversations from '../dashboard/DashboardConversations.vue';
import DashboardPendingReports from '../dashboard/DashboardPendingReports.vue';

// Composables
import { usePageHelper } from '@/composables/pageHelper';
import { storeToRefs } from 'pinia';

// Stores
import { useDashboardStore } from '@/stores/DashboardStore';

// Constants and Utils

// ===============================
// PROPS & EMITS
// ===============================

// ===============================
// COMPOSABLES & STORES
// ===============================
const dashboardStore = useDashboardStore();
const { organization, conversations, pendingReports } = storeToRefs(dashboardStore);
const pageHelper = usePageHelper();

// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================

// ===============================
// COMPUTED PROPERTIES
// ===============================

// ===============================
// METHODS
// ===============================
const handleRefreshOrganization = async () => {
  await pageHelper.fetch(() => dashboardStore.refreshOrganization());
};
// ===============================
// LIFECYCLE HOOKS
// ===============================
onMounted(async () => {
  await pageHelper.fetch(() => dashboardStore.fetch());
});

</script>
